import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Row} from 'reactstrap';
import images from '../images/images';

const CountryItemComponent = (props) => {
  return (
    <Row className={`country-item font-16 ${props.selected ? 'selected' : ''}`} onClick={() => props.action(props.country)}>
      <Col xs={11} className='p-0'>
        <span>
          <bdi>{props.country.countryHebName}</bdi>
        </span>
      </Col>
      <Col xs={1} className='text-left p-0'>
        {props.ConnectedCountryExistsPopupContent ? <Image src={images.pinkPlus} alt='icon' /> : <Image src={images.close} alt='icon' />}
      </Col>
    </Row>
  );
};

export default CountryItemComponent;
